import React from "react";
import {Row} from "react-bootstrap";

export const portfolioData = {
    name: {
        withSpaces: 'Shubhesh Dwivedi',
        noSpaces: 'shubheshdwivedi',
    },
    email: 'shubheshkdwivedi@gmail.com',
    promoContent: function () {
        return 'I\'m <strong>' + this.name.withSpaces + '</strong>, a passionate gameplay and tools '
            + 'engineer who loves to design and develop game-focused applications.'
    },
    about: {
        aboutInfo: ' Hi, I am  beginner level game developer and have hands on experience on developing games using Unity. I am aware of and adhere to the best practices for writing code, which is clean, maintainable and extendable. I also have experience of agile development practices and JIRA. I am flexible in my approaches and have an open mind towards new perspectives. I also contribute to open source organizations, primary one being  GNOME org (precisely GNOME Polari, an IRC client) on an occasional basis and have a good grasp on linux. A few skills I would like to highlight that would enable me to contribute to your project or organization are: <br/>\n' +
            '                                - Highly skilled in developing and testing software <br/>\n' +
            '                                - Good understanding of data structures and algorithms <br/>\n' +
            '                                - Knowledge of full <stack></stack> development cycle and best practices to be followed<br/>\n' +
            '                                - Hands-on software troubleshooting experience <br/>\n' +
            '                                I am a fast learner and love to expand my knowledge base, as continuing to learn new languages and development techniques are important to me and the success of your organization'
    },
    skills: {
        languages: 'C, C++, C#, Javascript (ES5 & ES6), Java, SQL, HTML5, CSS/Sass',
        tools: 'Node.js, Express, Unity, React (with Redux), MongoDB, Postgres, Git, Bootstrap',
        fields: 'Full stack development, Scripting, Game development, User Interface'
    },
    projects: {
        games: [
            {
                title: 'OneSide',
                type: 'Android Application | Webapp',
                desc: 'Oneside is mathematical puzzle game, in which you have to swap rows and columns up and down to ' +
                    'match the grid generated on a 3 x 3 board, using minimum number of moves.',
                platforms: [
                    {
                        'android': 'https://play.google.com/store/apps/details?id=com.nullbyte.oneside&hl=en',
                        'github': 'https://github.com/shubheshdwivedi/oneside',
                        'pc': 'https://oneside-9af7d.firebaseapp.com/'
                    }
                ],
                embed: 'y_7g6ZS1tyk'
            },
            {
                title: 'Twisted Rover',
                type: 'Windows Application | Webapp',
                desc: 'Twisted Rover is a platformer game built using Unity and C#. With simple goal and a minimalistic ' +
                    'controls you hop from one platform to another while avoiding obstacles, it provides 8 levels of sheer enjoyment.',
                platforms: [
                    {
                        'github': 'https://github.com/shubheshdwivedi/going-home',
                        'pc': 'https://shubheshdwivedi.itch.io/twisted-rover'
                    }
                ],
                embed: 'GHf7J1pJyhQ'
            },
            {
                title: 'Galaxy Shooter',
                type: 'Windows Application | Webapp',
                desc: 'Galaxy shooter is an inspired arcade shooter from old games such as Spaceships. You have to destroy' +
                    ' enemy ships while collecting power ups and boosts to maximize your score. It is implemented using Unity and C#.',
                platforms: [
                    {
                        'github': 'https://github.com/shubheshdwivedi/galaxy-shooter',
                        'pc': 'https://shubheshdwivedi.itch.io/galaxy-shooter'
                    }
                ],
                embed: 'R7gVGkBEy3o'
            },
            {
                title: 'Legacy Hacker',
                type: 'Windows Application | Webapp',
                desc: 'Implemented using Unity, Legacy Hacker is text based, matrix themed word guessing game. You have to choose a difficulty' +
                    ' you want to play at, and then crack the word using its anagram.',
                platforms: [
                    {
                        'github': 'https://github.com/shubheshdwivedi/galaxy-shooter',
                        'pc': 'https://shubheshdwivedi.itch.io/galaxy-shooter'
                    }
                ],
                embed: 'mnuLj-ShHTQ'
            }
        ],
        webApps: [
            {
                title: 'TeenPatti',
                type: 'Webapp',
                desc: 'Implemented using MERN stack, TeenPatti is a realtime online multiplayer developed as a freelance work' +
                    ' for a private organization. Socket.io was used to enable realtime engagements among players',
                platforms: [],
                embed: 'https://i.ibb.co/f8nfn1V/teen-Patti.png'
            },
            {
                title: 'cli-dictionary',
                type: 'CLI app',
                desc: 'Cli dictionary is a command line tool to get dictionary information about any word using the command line' +
                    ' or terminal. It is implemented using Nodejs runtime environment and uses an external API to fetch definitions.',
                platforms: [
                    {
                        'github': 'https://github.com/shubheshdwivedi/cli-dictionary',
                    }
                ],
                embed: 'https://i.ibb.co/rFRCJNX/Screenshot-from-2020-04-26-20-53-08.png'

            },
            {
                title: 'Mewtter',
                type: 'Webapp',
                desc: 'A twitter with a cat theme maybe? :) Mewtter is built using Nodejs, Express and Mongo on the backend and' +
                    ' and uses React (+Redux) for the frontend. ',
                platforms: [
                    {
                        'github': 'https://github.com/shubheshdwivedi/mewtter',
                    }
                ],
                embed: 'https://i.ibb.co/pJGXF6t/Screenshot-from-2020-04-26-20-54-42-2.png'
            },
            {
                title: 'Truber',
                type: 'Backend Applicaiton',
                desc: 'Truber is a webapp to enable uber like model for trucking business. It was developed as summer project under NEC Technologies.' +
                    ' It is written using Spring and MySQL, whereas the frontend is built in React.',
                platforms: [
                    {
                        'github': 'https://github.com/shubheshdwivedi/mewtter',
                    }
                ],
                embed: 'https://i.ibb.co/BqhCX1H/Screenshot-from-2020-04-26-21-06-21.png'
            },
        ]
    },
    contact: {
        promoContent: 'I\'m actively looking for any new opportunities and my inbox is always open. Whether you have a ' +
            'question or just want to say hi, hit me up, I\'ll try my best to get back to you!'
    },
    resume: 'https://drive.google.com/open?id=1zGcUyUJ1Au21clEwZq2s7SqkfWFkV6XB',
    github: 'https://github.com/shubheshdwivedi',
    instagram: 'https://www.instagram.com/shubhesh_dwivedi/',
    linkedin: 'https://www.linkedin.com/in/shubheshdwivedi/'
};

export const sectionHeaders = (heading) => <Row>
    <h1 className={'section-header'}><strong>{heading}</strong></h1>
</Row>;

export const mailLink = 'mailto:shubheshkdwivedi@gmail.com';
